export default __webpack_public_path__ + "static/media/study.cdd957d2.png";